import { modalActions } from "@context/modals";
import usePreviousUrl from "@shared/hooks/usePreviousUrl";
import { Button } from "@shared/components";
import { BUTTON_SIZE, BUTTON_VARIANT } from "@shared/components/button/types";
import ChatIcon from "@svg/new-design/chat-icon";
import classNames from "classnames";
import { MODAL_TYPES } from "types/modals";

const FeedbackFab = () => {
  const previousUrl = usePreviousUrl();
  const handleOpenFeedbackModal = () => {
    modalActions.addModal(MODAL_TYPES.FEEDBACK, {
      config: {
        hideCloseIcon: true,
        modalClassName: "overflow-y-auto",
      },
      data: {
        previousUrl: previousUrl ?? "",
      },
    });
  };
  const className = "-rotate-90 fixed z-[100] cursor-pointer  bottom-[176px]";
  return (
    <>
      <Button
        variant={BUTTON_VARIANT.GHOST}
        size={BUTTON_SIZE.MEDIUM}
        className={classNames("flex fds-sm:hidden -left-8 ", className)}
        onClick={handleOpenFeedbackModal}
      >
        گزارش مشکل
      </Button>
      <Button
        startIcon={<ChatIcon className="" />}
        variant={BUTTON_VARIANT.GHOST}
        size={BUTTON_SIZE.XLARGE}
        className={classNames("hidden fds-sm:flex  -left-14", className)}
        onClick={handleOpenFeedbackModal}
      >
        گزارش مشکل
      </Button>
    </>
  );
};

export default FeedbackFab;
